import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Bars3Icon } from '@heroicons/react/24/outline';
import Drawer from "./Drawer";
import Drawerdata from "./Drawerdata";

const navigation = [
    { name: 'Home', href: '/', current: false },
    { 
        name: 'Services', 
        href: '/services',
        current: false 
    },
    { name: 'Who We Are', href: '/about', current: false },
    { name: 'Contact', href: '/contact', current: false },
];

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const Navbar = () => {
    const [isOpen, setIsOpen] = React.useState(false);
    const location = useLocation();

    return (
        <nav className="bg-white shadow-md fixed w-full z-50">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-20">
                    <div className="flex items-center">
                        {/* Logo */}
                        <Link to="/" className="flex items-center gap-3">
                            <div className="relative h-16 w-16">
                                <img
                                    src="/images/logo.png"
                                    alt="JIL Logo"
                                    className="object-contain w-full h-full"
                                />
                            </div>
                            <div className="flex flex-col">
                                <span className="text-m font-medium text-black uppercase">Junction</span>
                                <span className="text-m font-medium text-black uppercase">Integrated Logistics</span>
                            </div>
                        </Link>
                    </div>

                    {/* Desktop Navigation */}
                    <div className="hidden lg:flex items-center space-x-8">
                        {navigation.map((item) => (
                            <Link
                                key={item.name}
                                to={item.href}
                                className={`px-3 py-2 text-lg font-medium transition-colors duration-300 ${
                                    location.pathname === item.href 
                                    ? 'text-[#052c65] font-semibold'
                                    : 'text-gray-700 hover:text-[#052c65]'
                                }`}
                            >
                                {item.name}
                            </Link>
                        ))}
                        <Link 
                            to="/contact"
                            className="bg-[#29abe2] text-white px-6 py-3 rounded-lg hover:bg-[#052c65] transition duration-300"
                        >
                            <div className="text-sm font-medium">Get in Touch</div>
                            <div className="text-lg font-semibold">(562) 618-4677</div>
                        </Link>
                    </div>

                    {/* Mobile menu button */}
                    <div className="flex lg:hidden items-center">
                        <Bars3Icon 
                            className="h-6 w-6 text-gray-700 cursor-pointer" 
                            onClick={() => setIsOpen(true)}
                        />
                    </div>
                </div>
            </div>

            {/* Mobile Navigation Drawer */}
            <Drawer isOpen={isOpen} setIsOpen={setIsOpen}>
                <Drawerdata />
            </Drawer>
        </nav>
    );
};

export default Navbar; 